import React, { useState, useEffect } from "react";
import "./home.scss";
import Chart, {
  CommonSeriesSettings,
  SeriesTemplate,
} from "devextreme-react/chart";
import { Legend, Subtitle, Title } from "devextreme-react/bar-gauge";
import { Export } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useDispatch, useSelector } from "react-redux";

import * as languageItemActions from "../../actions/languageItemActions";

export default () => {
  // const {t, changeLanguage} = useLanguage();
  const dispatch = useDispatch();

  function customizeSeries(valueFromNameField) {
    return valueFromNameField === 12
      ? { type: "line", label: { visible: true }, color: "#ff3f7a" }
      : {};
  }

 
  const [store, setStore] = useState(
    new CustomStore({
      load: () => {
        return [];
      },
      key: "languageName",
    })
  );

  const languageItemIstatisticsList = useSelector( (state) => state.languageItemIstatistics.languageItemIstatisticsList ); //state bu şekilde dinleniyor

  useEffect(() => {
    dispatch(languageItemActions.getIstatisticsList());
  }, []);

  useEffect(() => {
    setStore(
      new CustomStore({
        load: () => {
          return languageItemIstatisticsList;
        },
        key: "languageName",
      })
    );
  }, [languageItemIstatisticsList]);

  return (
    <Chart id="chart" palette="Violet" dataSource={store}> 
      <SeriesTemplate nameField="audioFileNameCount" customizeSeries={customizeSeries} />
      <CommonSeriesSettings
        argumentField="languageName"
        valueField="languageItemCount"
        type="bar"
      />
      {/* <Title text="Oil Production">
        <Subtitle text="(in millions tonnes)" />
      </Title>
      <Legend verticalAlignment="bottom" horizontalAlignment="center" />
      <Export enabled={true} /> */}
    </Chart>
  );
};
